import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faFacebook,
    faInstagram,
    faLinkedin,
    faTwitter,
    faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import {
    faCalendarAlt,
    faCalendarXmark,
    faCheckCircle,
    faCheckSquare as faCheckSquareRegular,
    faComments as faCommentsRegular,
    faCopy,
    faCopyright,
    faCreditCard,
    faEdit,
    faFileAlt as faFileAltRegular,
    faFrown,
    faHandshake,
    faMap,
    faQuestionCircle as faQuestionCircleRegular,
    faSquare as faSquareRegular,
    faStar,
    faThumbsUp,
    faTimesCircle,
    faTrashAlt,
    faUserCircle,
} from '@fortawesome/free-regular-svg-icons';
import {
    faAt,
    faAlignLeft,
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faAngleLeft,
    faAngleRight,
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faArrowUp,
    faAsterisk,
    faAward,
    faBan,
    faBars,
    faBell,
    faBolt,
    faBook,
    faBoxesStacked,
    faCalculator,
    faCalendarCheck,
    faCalendarDay,
    faCalendarDays,
    faCircleArrowUp,
    faCircleArrowDown,
    faCity,
    faCode,
    faComments,
    faChartBar,
    faChartLine,
    faCheck,
    faCheckCircle as faCheckCircleSolid,
    faCheckSquare,
    faChevronCircleLeft,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faClipboardList,
    faClock,
    faClone,
    faCloudUploadAlt,
    faCog,
    faCogs,
    faColumns,
    faCommentDots,
    faCompress,
    faCookieBite,
    faCube,
    faDatabase,
    faDna,
    faDolly,
    faDollyFlatbed,
    faDownload,
    faEarthAmerica,
    faEllipsisH,
    faEllipsisV,
    faEnvelope,
    faEquals,
    faExchangeAlt,
    faExclamation,
    faExclamationCircle,
    faExclamationTriangle,
    faExpand,
    faExpandArrowsAlt,
    faExternalLinkAlt,
    faExternalLinkSquareAlt,
    faEye,
    faEyeSlash,
    faFileAlt as faFileAltSolid,
    faFileCode,
    faFileCsv,
    faFileDownload,
    faFileExcel,
    faFileExport,
    faFileImport,
    faFileSignature,
    faFileUpload,
    faFilter,
    faFingerprint,
    faFolder,
    faFolderOpen,
    faFolderPlus,
    faFolderTree,
    faFont,
    faGhost,
    faGlobe,
    faGraduationCap,
    faHammer,
    faHashtag,
    faHeadset,
    faHistory,
    faHome,
    faHourglassHalf,
    faIcons,
    faIdCard,
    faInbox,
    faInfoCircle,
    faKey,
    faLayerGroup,
    faLifeRing,
    faLink,
    faListAlt,
    faListUl,
    faLock,
    faLockOpen,
    faMagic,
    faMapLocationDot,
    faMoneyBillAlt,
    faMinus,
    faMinusSquare,
    faNotEqual,
    faNotesMedical,
    faPaintRoller,
    faPaperPlane,
    faPalette,
    faPause,
    faPauseCircle,
    faPencilAlt,
    faPenToSquare,
    faPercentage,
    faPhone,
    faPlay,
    faPlug,
    faPlus,
    faPlusSquare,
    faProjectDiagram,
    faPuzzlePiece,
    faRandom,
    faRecycle,
    faRoad,
    faRedoAlt,
    faRepeat,
    faSave,
    faSearch,
    faSearchDollar,
    faSeedling,
    faShareAlt,
    faShieldAlt,
    faSignInAlt,
    faSignOutAlt,
    faSitemap,
    faShieldHalved,
    faSkull,
    faSlidersH,
    faSort,
    faSortAmountUpAlt,
    faSortAmountDown,
    faSortNumericDownAlt,
    faSortNumericUp,
    faSpinner,
    faStar as faStarSolid,
    faStop,
    faStopCircle,
    faStream,
    faSwatchbook,
    faSyncAlt,
    faQuestionCircle as faQuestionCircleSolid,
    faQuestion,
    faTachometerAlt,
    faTag,
    faTasks,
    faTimes,
    faTimesCircle as faTimesCircleSolid,
    faToggleOn,
    faTools,
    faTruckLoading,
    faUndoAlt,
    faUnlink,
    faUser,
    faUserAstronaut,
    faUserCircle as faUserCircleSolid,
    faUserClock,
    faUserGroup,
    faUsers,
    faUserCheck,
    faUserSecret,
    faUsersSlash,
    faUserTie,
    faVial,
    faWallet,
    faWandMagicSparkles,
    faStopwatch,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faAddNote,
    faAdmin,
    faArrowRight as faArrowRightCustom,
    faBackup,
    faBrush,
    faCancel,
    faCombine,
    faFolderPause,
    faFunction,
    faJoin,
    faListTimes,
    faMerge,
    faMergeClear,
    faMergeExtension,
    faMergeFallback,
    faMergeNone,
    faMergePatch,
    faMergeUpdate,
    faMultiply,
    faOpenAI,
    faPercentageCircle,
    faPlusCircle,
    faPlusCircleMany,
    faRule,
    faSparkles,
    faStorageDown,
    faUnite,
    faVacuum,
    faWallClock,
} from './custom';

const brands = [
    faFacebook,
    faInstagram,
    faLinkedin,
    faTwitter,
    faYoutube,
];
const regular = [
    faCalendarAlt,
    faCalendarXmark,
    faCheckCircle,
    faCheckSquareRegular,
    faCommentsRegular,
    faCopy,
    faCopyright,
    faCreditCard,
    faEdit,
    faFileAltRegular,
    faFrown,
    faHandshake,
    faMap,
    faQuestionCircleRegular,
    faSquareRegular,
    faStar,
    faThumbsUp,
    faTimesCircle,
    faTrashAlt,
    faUserCircle,
];
const solid = [
    faAt,
    faAlignLeft,
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faAngleLeft,
    faAngleRight,
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faArrowUp,
    faAsterisk,
    faAward,
    faBan,
    faBars,
    faBell,
    faBolt,
    faBook,
    faBoxesStacked,
    faCalculator,
    faCalendarCheck,
    faCalendarDay,
    faCalendarDays,
    faCircleArrowUp,
    faCircleArrowDown,
    faCity,
    faCode,
    faComments,
    faChartBar,
    faChartLine,
    faCheck,
    faCheckCircleSolid,
    faCheckSquare,
    faChevronCircleLeft,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faClipboardList,
    faClock,
    faClone,
    faCloudUploadAlt,
    faCog,
    faCogs,
    faColumns,
    faCommentDots,
    faCompress,
    faCookieBite,
    faCube,
    faDatabase,
    faDna,
    faDolly,
    faDollyFlatbed,
    faDownload,
    faEarthAmerica,
    faEllipsisH,
    faEllipsisV,
    faEnvelope,
    faEquals,
    faExchangeAlt,
    faExclamation,
    faExclamationCircle,
    faExclamationTriangle,
    faExpand,
    faExpandArrowsAlt,
    faExternalLinkAlt,
    faExternalLinkSquareAlt,
    faEye,
    faEyeSlash,
    faFileAltSolid,
    faFileCode,
    faFileCsv,
    faFileDownload,
    faFileExcel,
    faFileExport,
    faFileImport,
    faFileSignature,
    faFileUpload,
    faFilter,
    faFingerprint,
    faFolder,
    faFolderOpen,
    faFolderPlus,
    faFolderTree,
    faFont,
    faGhost,
    faGlobe,
    faGraduationCap,
    faHammer,
    faHashtag,
    faHeadset,
    faHistory,
    faHome,
    faHourglassHalf,
    faIcons,
    faIdCard,
    faInbox,
    faInfoCircle,
    faKey,
    faLayerGroup,
    faLifeRing,
    faLink,
    faListAlt,
    faListUl,
    faLock,
    faLockOpen,
    faMagic,
    faMapLocationDot,
    faMoneyBillAlt,
    faMinus,
    faMinusSquare,
    faNotEqual,
    faNotesMedical,
    faPaintRoller,
    faPalette,
    faPaperPlane,
    faPause,
    faPauseCircle,
    faPencilAlt,
    faPenToSquare,
    faPercentage,
    faPhone,
    faPlay,
    faPlug,
    faPlus,
    faPlusSquare,
    faProjectDiagram,
    faPuzzlePiece,
    faRandom,
    faRecycle,
    faRepeat,
    faRedoAlt,
    faRoad,
    faSave,
    faSearch,
    faSearchDollar,
    faSeedling,
    faShareAlt,
    faShieldAlt,
    faSignInAlt,
    faSignOutAlt,
    faSitemap,
    faShieldHalved,
    faSkull,
    faSlidersH,
    faSort,
    faSortAmountUpAlt,
    faSortAmountDown,
    faSortNumericDownAlt,
    faSortNumericUp,
    faSpinner,
    faStarSolid,
    faStop,
    faStopCircle,
    faStream,
    faSwatchbook,
    faSyncAlt,
    faTachometerAlt,
    faTag,
    faQuestionCircleSolid,
    faQuestion,
    faTasks,
    faTimes,
    faTimesCircleSolid,
    faToggleOn,
    faTools,
    faTruckLoading,
    faUndoAlt,
    faUnlink,
    faUser,
    faUserAstronaut,
    faUserCircleSolid,
    faUserClock,
    faUserGroup,
    faUsers,
    faUserCheck,
    faUserSecret,
    faUsersSlash,
    faUserTie,
    faVial,
    faWallet,
    faWandMagicSparkles,
    faStopwatch,
];
const custom = [
    faAddNote,
    faAdmin,
    faArrowRightCustom,
    faBackup,
    faBrush,
    faCancel,
    faCombine,
    faFolderPause,
    faFunction,
    faJoin,
    faListTimes,
    faMerge,
    faMergeClear,
    faMergeExtension,
    faMergeFallback,
    faMergeNone,
    faMergePatch,
    faMergeUpdate,
    faMultiply,
    faOpenAI,
    faPercentageCircle,
    faPlusCircle,
    faPlusCircleMany,
    faRule,
    faSparkles,
    faStorageDown,
    faUnite,
    faVacuum,
    faWallClock,
];

library.add(...brands, ...regular, ...solid, ...custom);

Vue.component('FontAwesomeIcon', FontAwesomeIcon);
